import React from "react";
import HeaderHome from "../components/home/headerHome";

const Home = () => {


  return (
    <div className="home">
      <HeaderHome />
      <a href="Game" className="btn-grad">¡Jugar ahora!</a>
   
    </div>
  );
};

export default Home;